import { inject, Pipe, PipeTransform } from '@angular/core';
import { Person } from 'src/app/model/Person';
import { UserService } from 'src/app/services/user/user.service';

/**
 * Pipe that checks if the given person corresponds to the currently logged-in user.
 * If this is true, it appends "(You)" to the person's full name.
 */
@Pipe({
  name: 'isYou',
  standalone: true
})
export class IsYouPipe implements PipeTransform {
  /** Injected dependencies */
  private _userService: UserService = inject(UserService);

  transform(value: unknown, ...args: unknown[]): unknown {
    // Ensure the second argument is an email
    const email = args[0];
    if (typeof email !== 'string') return value;

    // Ensure value is a string
    const fullName = value as string;
    if (!fullName) return value;

    // Compare with the logged-in user's email
    const currentUserEmail = this._userService.user?.email.toLowerCase();
    if (currentUserEmail && email.toLowerCase() === currentUserEmail) {
      return `${fullName} (You)`;
    }
    return fullName;
  }

}
